import { render, staticRenderFns } from "./GroupDetailBase.vue?vue&type=template&id=e49ce392&"
import script from "./GroupDetailBase.vue?vue&type=script&lang=js&"
export * from "./GroupDetailBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports